import type { PersonalizationStep } from '@heidi/growth/contracts';

/** The three screens the guided-tour arm splits `note-edit` into. */
export const GUIDED_TOUR_STEPS = [
  'tour-detail',
  'tour-artefacts',
  'tour-evidence',
] as const;

export type GuidedTourStep = (typeof GUIDED_TOUR_STEPS)[number];

export function isGuidedTourStep(step: PersonalizationStep): step is GuidedTourStep {
  return (GUIDED_TOUR_STEPS as readonly string[]).includes(step);
}
